import 'core-js/stable'

import './vendor.less'

import invariant from 'invariant'
import { createRoot } from 'react-dom/client'
import { init } from '@signavio/i18n'

import SignavioWorkflowPublicForms from './containers'
import { config, getLangLoader } from './locales'

void init(getLangLoader, config).then(() => {
  const container = document.getElementById('public-form')

  invariant(container, 'Could not find root node for public forms.')

  const root = createRoot(container)
  root.render(<SignavioWorkflowPublicForms />)
})
